export const FLOW_TYPES = {
  HAPPY_FLOW: 'happy',
  UNHAPPY_FLOW: 'unhappy',
} as const;

export type FLOW_TYPES = keyof typeof FLOW_TYPES;
export type FLOW_VALUES = (typeof FLOW_TYPES)[FLOW_TYPES];
